import {ObserverHub} from 'sopix/utils/observers'

export const apiEndPointOnStart = new ObserverHub()
export const apiEndPointOnFinalize = new ObserverHub()
